var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "experiences-filter-container container" },
    [
      _c("div", { staticClass: "heading-wrapper" }, [
        _c("h2", { staticClass: "heading-title" }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
        ]),
      ]),
      _vm._v(" "),
      _c("experiences-list", {
        attrs: {
          options: _vm.options,
          experiences: _vm.items,
          categories: _vm.categories,
          dictionary: _vm.dictionary,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }